import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext();

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [openModals, setOpenModals] = useState(new Set());

  // 註冊 Modal 開啟
  const registerModal = useCallback((modalId) => {
    setOpenModals(prev => {
      const newSet = new Set(prev);
      newSet.add(modalId);
      return newSet;
    });
  }, []);

  // 註銷 Modal 關閉
  const unregisterModal = useCallback((modalId) => {
    setOpenModals(prev => {
      const newSet = new Set(prev);
      newSet.delete(modalId);
      return newSet;
    });
  }, []);

  // 關閉所有 Modal
  const closeAllModals = useCallback(() => {
    setOpenModals(new Set());
  }, []);

  // 檢查是否有其他 Modal 開啟
  const hasOtherModals = useCallback((modalId) => {
    return Array.from(openModals).some(id => id !== modalId);
  }, [openModals]);

  const value = {
    openModals,
    registerModal,
    unregisterModal,
    closeAllModals,
    hasOtherModals,
    hasAnyModal: openModals.size > 0
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};

